/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { ResourceModel } from 'apmui/resource/Model';
import { RESOURCE } from 'apmui/resource/ResourceType';

class OauthScopeModel extends ResourceModel {
    //
    static readonly propNames = [...ResourceModel.propNames];
    //
    type: RESOURCE.OAUTH_SCOPE = RESOURCE.OAUTH_SCOPE;

    getPropNames(): string[] {
        return OauthScopeModel.propNames;
    }
}

export { OauthScopeModel as default, OauthScopeModel };
